import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { useLang } from '../context/LangContext';
import ProductRow from '../components/ProductRow';
import Hero from '../components/Hero';
import TopSalesCard from '../components/TopSalesCard';
import { API_URL } from '../config';

const API = API_URL;

const Home = () => {
  const { t } = useLang();
  const [products, setProducts]           = useState([]);
  const [categories, setCategories]       = useState([]);
  const [loading, setLoading]             = useState(true);

  useEffect(() => {
    setLoading(true);
    axios.get(`${API}/products`)
      .then(r => setProducts(r.data.data))
      .catch(() => setProducts([]))
      .finally(() => setLoading(false));
  }, []);

  useEffect(() => {
    axios.get(`${API}/products/categories`)
      .then(r => setCategories(r.data.data.filter(c => c.id !== 'all')))
      .catch(() => setCategories([]));
  }, []);

  const byCategory = (cat) => products.filter(p => p.category === cat);

  // Une rangée par catégorie qui a réellement des produits en base (triées par volume de stock côté API)
  const sections = categories.map(c => ({
    id: c.id,
    icon: c.icon,
    titleKey: `section_${c.id.replace(/-/g, '_')}`,
    fallbackLabel: c.label,
  }));

  const topSales = [...products]
    .sort((a, b) => (Number(b.rating) || 0) - (Number(a.rating) || 0))
    .slice(0, 4);

  return (
    <main>
      <Hero />

      {!loading && topSales.length > 0 && (
        <section className="top-sales">
          <div className="top-sales__inner">
            <div className="top-sales__header">
              <h2 className="top-sales__title">{t('top_sales_title')}</h2>
              <a href="#products" className="top-sales__link">{t('top_sales_see_all')} →</a>
            </div>
            <div className="top-sales__grid">
              {topSales.map(p => <TopSalesCard key={p.id} product={p} />)}
            </div>
          </div>
        </section>
      )}

      <div id="products" className="category-rows">
        {loading ? (
          <div className="loader-grid">
            {[...Array(4)].map((_, i) => <div key={i} className="skeleton-card" />)}
          </div>
        ) : (
          sections
            .filter(sec => byCategory(sec.id).length > 0)
            .map(sec => (
              <ProductRow
                key={sec.id}
                id={sec.id}
                title={t(sec.titleKey) !== sec.titleKey ? t(sec.titleKey) : sec.fallbackLabel}
                icon={sec.icon}
                products={byCategory(sec.id)}
              />
            ))
        )}
      </div>
    </main>
  );
};

export default Home;
